/* eslint-disable no-console */
import React, { useRef, useState, useContext } from 'react';
import { Box, Stack, Title, Button, Grid, Center, Image, Input, Space, Text } from '@mantine/core';
import { NotificationsProvider, showNotification } from '@mantine/notifications';
import { useForm } from '@mantine/form';
import { IconCheck, IconX } from '@tabler/icons';
import { useNavigate, createSearchParams } from 'react-router-dom';
import Keyboard from 'react-simple-keyboard';
import BasicLayout from '../../components/BasicLayout';
import 'react-simple-keyboard/build/css/index.css';
import logo from '../../image/hyperthings-logo.png';
import { sendRequest } from '../../services/services';
import AppContext from '../../components/Context/index';
import CountryCodeSelect from '../../components/CountryCodeSelect/CountryCodeSelect';

const Login = () => {
  const navigate = useNavigate();
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [inputData, setInputData] = useState('');
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');
  const [countrySelect, setCountrySelect] = useState();
  const [touched, setTouched] = useState(false);
  const appContextState = useContext(AppContext);
  const { handleUserLogin } = appContextState;

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      // mobile: null,
      country_code_id: 194,
    },
  });

  const [, setStatusCode] = useState();
  console.log('lll', localStorage.getItem('token'));
  const generateOtp = () => {
    const body = { mobile: inputData, country_code_id: countrySelect };
    sendRequest(`cashier/generate-otp`, 'post', body)
      .then(({ data, code, msg: message }) => {
        showNotification({
          ...(code === 20
            ? { icon: <IconCheck size={18} />, color: 'teal', message }
            : { icon: <IconX size={18} />, color: 'red', message }),
        });
        if (code === 20) {
          navigate({
            pathname: '/verify',
            search: createSearchParams({
              mobile: inputData,
              countryCode: countrySelect,
            }).toString(),
          });
          // console.log('res', code, data);
          handleUserLogin(data);
          showNotification({
            title: <Text weight={500}>Success full send OTP</Text>,
          });
        }
        setStatusCode(code);
      })

      .catch((err) => {
        if (err?.response?.data?.code) {
          setStatusCode(err?.response?.data?.code);
          showNotification({
            icon: <IconX size={18} />,
            color: 'red',
            message: err?.response?.data?.msg,
          });
        }
      });
  };

  const searchTicket = () => {
    // console.log('Sadas', dummyInput + inputData);
  };

  const onChangeInputNumber = (event) => {
    const data = String(event.target.value).replace(/\D/g, '').slice(0, 12);
    setInputData(data);
    setTouched(true);
    if (keyboard.current && keyboard.current.getInput() !== data) {
      keyboard.current.setInput(data);
    }
  };

  const onChangeNumber = (inputValue) => {
    const data = String(inputValue).replace(/\D/g, '').slice(0, 12);
    setInputData(data);
    setTouched(true);
    if (keyboard.current && keyboard.current.getInput() !== data) {
      keyboard.current.setInput(data);
    }
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    // console.log('Button pressed', button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') searchTicket();
  };

  const countrySelection = (e) => {
    setCountrySelect(e);
  };
  const showError = touched && (inputData.length < 7 || inputData.length > 12);

  return (
    <BasicLayout>
      <NotificationsProvider position="bottom-center">
        <Box>
          <Grid>
            <Grid.Col span={6} offset={3}>
              <Box
                sx={(theme) => ({
                  backgroundColor:
                    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
                  padding: theme.spacing.xl,
                  borderRadius: theme.radius.md,
                })}
              >
                <Center>
                  <Image radius="md" src={logo} alt="Random unsplash image" width="200px" />
                </Center>

                <Center py="xl">
                  <Title order={3}>Login by OTP</Title>
                </Center>

                <form onSubmit={form.onSubmit((values) => console.log(values))}>
                  <Stack size="xs">
                    <CountryCodeSelect
                      required
                      label="Country Code"
                      autoComplete="country Code"
                      // value={...form.getInputProps('country_code_id')}
                      onChange={countrySelection}
                    />

                    <Input.Wrapper label="Phone Number" required>
                      <Input
                        type="number"
                        placeholder="+91 7889675235"
                        {...form.getInputProps('number')}
                        value={inputData}
                        onChange={onChangeInputNumber}
                        maxLength={12}
                        minLength={7}
                      />
                      {showError && (
                        <Text fz="xs" color="red">
                          Mobile Number min 7 and max 12
                        </Text>
                      )}
                    </Input.Wrapper>
                  </Stack>
                  <Center py="lg">
                    <Button onClick={generateOtp}>Send OTP</Button>
                  </Center>

                  {/* <div style={{ marginTop: '10px' }}>
                <Center>
                  <OTPInput
                    OTPLength={4}
                    // placeholder="1234"
                    inputStyles={{
                      width: '60px',
                      height: '40px',
                      fontSize: '1.5rem',
                    }}
                    value={dummyInput}
                    onChange={onChangeInput}
                  />
                </Center>

                <Anchor component="a" style={{ float: 'right' }} p="xs">
                  Resend OTP
                </Anchor>
              </div>
              <Space h="xl" />
              <Space h="xl" />
              <Center py="xl">
                <Group>
                  <Button type="submit" style={{ width: '100%' }} onClick={verifyOTP}>
                    Submit OTP
                  </Button>
                </Group>
              </Center> */}
                </form>
              </Box>

              <Space h="xl" />

              <div dir="ltr">
                <Keyboard
                  // eslint-disable-next-line no-return-assign
                  keyboardRef={(r) => (keyboard.current = r)}
                  onChange={onChangeNumber}
                  onKeyPress={onKeyPress}
                  layoutName={layout}
                  maxLength={12}
                  layout={{
                    default: ['1 2 3 4 5 6 7 8 9 0 {bksp}'],
                    shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                  }}
                  display={{
                    '{bksp}': '⌫',
                    '{enter}': 'Enter',
                  }}
                />
              </div>

              <Space h="xl" />

              {/* <Keyboard
            // eslint-disable-next-line no-return-assign
            keyboardRef={(r) => (keyboard.current = r)}
            onChange={onInputChange}
            onKeyPress={onKeyPress}
            layoutName={layout}
            layout={{
              default: ['1 2 3 4 5 6 7 8 9 0 {bksp}'],
              shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
            }}
            display={{
              '{bksp}': '⌫',
              '{enter}': 'Enter',
            }}
          /> */}
            </Grid.Col>
          </Grid>
        </Box>
      </NotificationsProvider>
    </BasicLayout>
  );
};

export default Login;
